'use strict';

angular.module('shiftTraderApp')
  .directive('saWorkingWithGrid', function () {
    return {
      templateUrl: 'views/directives/saWorkingWithGrid.html',
      restrict: 'EA',
      scope: {
        selectedUser: '=',
        me: '=',
        workPeriod: '=',
        numToShow: '@'
      },
      controller: 'saWorkingWithCtrl'
    };
  });
